<template>
  <div class="tc">
    <h5>
      {{ location }} - {{ year }}
      <br>{{ indicator }}
      <br>View by: {{ viewBy }}
      <br>Response: {{ response }}
    </h5>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    filterState: {
      type: Object,
      default() {
        return {
          allYears: false,
          yearId: '',
          stratCatId1: '',
          stratId1: '',
          stratCatId2: '',
          stratId2: '',
          responseId: '',
          dataValueTypeId: '',
        };
      },
    },
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      GSGo: state => state.SP.GSGo,
      indicators: state => state.SP.indicators,
    }),
    location() {
      return this.GSGo.location;
    },
    year() {
      if (this.filterState.allYears) return 'All available years';
      return this.lku.Year[this.filterState.yearId].name;
    },
    indicator() {
      return this.indicators[this.instance].name;
    },
    viewBy() {
      if (this.filterState.stratCatId1 === process.env.OverallStratCatId) {
        return this.lku.StratificationCategory[this.filterState.stratCatId1].name;
      }
      const stratCat1 = this.lku.StratificationCategory[this.filterState.stratCatId1].name;
      const strat1 = this.filterState.stratId1 ? ` - ${this.lku.Stratification[this.filterState.stratId1].name}` : '';
      const stratCat2 = this.filterState.stratCatId2 ? `; ${this.lku.StratificationCategory[this.filterState.stratCatId2].name}` : '';
      const strat2 = this.filterState.stratId2 ? ` - ${this.lku.Stratification[this.filterState.stratId2].name}` : '';
      return `${stratCat1}${strat1}${stratCat2}${strat2}`;
    },
    response() {
      return this.filterState.responseId ? this.lku.Response[this.filterState.responseId].name : 'All';
    },
  },
};
</script>


<style scoped>
  .tc {
    text-align: center;
  }
  h5 {
    font-size: 14px;
    font-weight: bold;
    line-height: 25px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SP/SPViewTitle.vue